import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { BaseWidgetComponent } from '../base-widget.abstract';
import { Widgets } from '@common/enums';
import { CdkDrag, CdkDragPreview, CdkDragPlaceholder, CdkDragHandle } from '@angular/cdk/drag-drop';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { ViewResolverComponent } from '@web/layout/content/page-content/resolvers/view-resolver.component';
import { ItemControlsComponent } from '@web/layout/content/page-content/components/controls/item-controls/item-controls.component';
import { DragHandleComponent } from '@web/layout/content/page-content/components/drag-handle/drag-handle.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'web-specific-widget',
    templateUrl: './specific-widget.component.html',
    styleUrls: ['./specific-widget.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        CdkDrag,
        TooltipModule,
        CdkDragPreview,
        CdkDragPlaceholder,
        ViewResolverComponent,
        ItemControlsComponent,
        DragHandleComponent,
        CdkDragHandle,
        TranslateModule,
    ],
})
export class SpecificWidgetComponent extends BaseWidgetComponent {
    public readonly blockHasLogo = input<boolean>();

    protected readonly Widgets = Widgets;
    public isSpecific: boolean = true;
}
